/* Neue Studio custom JS for Xinú Perfumes */
/* External links open in a new tab */
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname != window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}

/* Roier Dev */
const FREE_GIFT_FLAG = true;
const FREE_GIFT_ID = 41966474920010;
const FREE_GIFT_DATA = {
  items: [
    {
      id: FREE_GIFT_ID,
      quantity: 1
    }
  ]
};

document.addEventListener('DOMContentLoaded', () => {
  const typoProducts = document.querySelector('.typo-products');
  const changeView = document.querySelectorAll('.change-view');

  const toggleView = (e) => {
    const { target: { nodeName } } = e;
    let link = e.target;
    if (nodeName === 'IMG') {
        link = link.parentNode;
    }
    const { dataset: { view } } = link;
    if (history.pushState) {
      let url = window.location.protocol + "//" + window.location.host + window.location.pathname;
      const params = Object.fromEntries(new URLSearchParams(window.location.search).entries());
      if (params.view) {
        params.view = view;
      }
      url += `?view=${view}`;
      window.history.pushState({path: url}, '', url);

      const buttons = Array.from(changeView);
      buttons
        .find((a) => view === a.dataset.view)
        .classList.add('active');

      buttons
        .find((a) => view !== a.dataset.view)
        .classList.remove('active');

      if (view === 'grid') {
        typoProducts.classList.add('product-grid');
        typoProducts.classList.remove('product-list');
      } else {
        typoProducts.classList.add('product-list');
        typoProducts.classList.remove('product-grid');
      }
    }
  }

  if (changeView) {
    Array.from(changeView).map((a) => {
      a.addEventListener('click', toggleView);
    });
  }

  let timer;
  function debounce(func, timeout = 300){
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func.apply(this, args);
      }, timeout);
    };
  }

  const images = Array.from(document.querySelectorAll('.logo-sub-menu-container figure'));
  const swapImage = (id) => {
    images
        .filter((figure) => figure.dataset.id !== id)
        .forEach((figure) => figure.classList.remove('active'));
      
      images.find((figure) => figure.dataset.id == id)?.classList?.add('active');
  }

  const mouseEnter = (e) => {
    const { target: { dataset: { collection } } } = e;
    if (collection) {
      const subNavBar = document.querySelector('.sub-navbar');
      const subHeader = document.querySelector('.sub-header');
      const logoSubNavBar = document.querySelector('.logo-sub-menu-container');

      if (subNavBar && subHeader && logoSubNavBar) {
        const collectionSubNav = subHeader.querySelectorAll(`ul[data-collection="${collection}"]`);
        subHeader.classList.add('active');
        if (collectionSubNav.length) {
          clearTimeout(timer);

          subNavBar.classList.add('show--sub-navbar');
          logoSubNavBar.classList.add('show--sub-navbar');

          Array.from(collectionSubNav).forEach((list) => {
            Array.from(list.parentElement.children)
              .filter((li) => li.dataset.collection !== collection)
              .forEach((li) => {
                li.classList.remove('active')
              });
          });
          Array.from(collectionSubNav).forEach((list) => list.classList.add('active'));
        }
      }
    }
  }

  const mouseLeave = () => {
    debounce(() => {
      document.querySelector('.sub-header')?.classList.remove('active');
      document.querySelector('.sub-navbar')?.classList.remove('show--sub-navbar');
      document.querySelector('.logo-sub-menu-container')?.classList.remove('show--sub-navbar');
    }, 300)();
  }

  const hasCollection = document.querySelectorAll('.has-collection');
  Array.from(hasCollection).forEach((ul) => {
    ul.addEventListener('mouseenter', mouseEnter);
    ul.addEventListener('mouseleave', mouseLeave);
  });

  Array.from(document.querySelectorAll('.sub-navbar ul li a')).forEach((product) => {
    product.addEventListener('mouseenter', (e) => {
      const { target: { dataset: { id } } } = e;
      swapImage(id);
    });
  });

  const addToEvents = (selector) => {
    document.querySelector(selector).addEventListener('mouseenter', () => { clearTimeout(timer) });
    document.querySelector(selector).addEventListener('mouseleave', mouseLeave);
  }
  addToEvents('.sub-header');

  let options = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' }
  };

  window.addEventListener('SCE:mutate', async (event) => {
    if (!FREE_GIFT_FLAG) { return; }
    const cart = await (await fetch('/cart.js')).json();
    const { item_count } = cart;
    const hasGift = cart.items.find(({ id }) => id === FREE_GIFT_ID) !== undefined;

    if (!hasGift && item_count > 0) {
      console.log('adding free gift...');
      await (await fetch(window.Shopify.routes.root + 'cart/add.js', {
        ...options,
        body: JSON.stringify(FREE_GIFT_DATA)
      })).json()
    } else if (item_count === 1 && hasGift) {
      console.log('removing free gift...');
      await (await fetch(window.Shopify.routes.root + 'cart/update.js', {
        ...options,
        body: JSON.stringify({ updates: { [FREE_GIFT_ID]: 0 }})
      })).json()
    }
    setTimeout(typo?.updateDropdownCart, 1)
  });

});
